export const INCIDENT_PAGE_VIEWS = ["cards", "all"] as const;

export type IncidentPageView = (typeof INCIDENT_PAGE_VIEWS)[number];

export function isIncidentPageView(value: string): value is IncidentPageView {
    return INCIDENT_PAGE_VIEWS.some((view) => view === value);
}
